import PropTypes from "prop-types"
import React, { Component } from "react";
import { withRouter } from "react-router";

import Card from "./components/cards";
import Header from "components/header";
import Option from "components/select-option/option";
import Loading from "components/center-loading";
import Message from "components/message";
import SelectOption from "components/select-option";
import FiltroProgramacao from "components/filters/filter-programacao";
import Session from "utils/user-storage";
import StorePersist from "utils/store-persist";

import IconEmpty from "images/iconEmpty.icon";

import intl from 'react-intl-universal'

import "./stocks.css";
import ListStocks from "./components/list-stocks";
import Pagination from "components/pagination";

import * as service from './stocks.service';
import { formatErrorMessage } from 'utils/handle-error';
import FilterStock from "./components/filter";
import { filtersStocksDefault } from "./components/filter/utils";
import { mapDtoRequestStocks, mapDtoResponseStocks } from "./utils/index";
import { verifyIsFiltered } from "utils/custom-functions";
import { IconCalendarSchedule, ImgGrid, ImgLista as IconList } from "components/icons/icn-index.icon";
import Sidebar from "components/sidebar";
import ButtonIcon from "components/button-icon";
import { IconFilterActive } from "components/icons/icn-filter-active.icon";
import { IconFilterInactive } from "components/icons/icn-filter-inactive.icon";

export const PERFIL_PCP_UNIDADE = { value: 4 };
export const TIPO_VISUALIZACAO_GRID = 'Grid'

export const scrollToRef = ref =>
  ref.current.scrollIntoView({ behavior: 'smooth', block: 'start' });

class Stocks extends Component {
  static propTypes = {
    history: PropTypes.shape({
      push: PropTypes.func
    }).isRequired
  }

  constructor() {
    super();

    this.contentScroll = React.createRef();

    this.state = {
      requestCounter: 0,
      showFilter: false,
      showFilterProgramacao: false,
      loadRegs: 0,
      regsPerRequest: 50,
      totalStocks: 0,
      stocks: [],
      useFilterDefault: false,
      filters: filtersStocksDefault,
      filtersProgramacao: {
        idUsuarioProgramado: "",
        usuarioSelecionado: {
          Descricao: intl.get('stocks.header.actions.userNotSelected')
        },
        programados: true,
        naoProgramados: true
      },
      usuariosProgramacao: [],
      etapas: [],
      status: [],
      unidadesNegocio: [],
      familiasRotuladas: [],
      carteiras: [],
      materiaisAtivos: [],
      familias: [],
      coordenacoes: [],
      suppliers: [],
      tipoVisualizacaoEstoque: "Grid",
      showMsg: false,
      titleMsg: "",
      textMsg: "",
    };
  }

  componentDidMount() {
    this.loadPage();
  }

  loadPage = async () => {
    const tipoVisualizacaoEstoque = StorePersist.getValuesJSON("tipoVisualizacaoEstoque");

    this.setState(prevState => ({
      tipoVisualizacaoEstoque: tipoVisualizacaoEstoque ?? prevState.tipoVisualizacaoEstoque
    }));

    const filterMyItensOnly = StorePersist.getValuesJSON("filterMyItemsOnly")

    this.setState({
      useFilterDefault: filterMyItensOnly
    });

    const filterSchedule = StorePersist.getValuesJSON("filterSchedule")
    
    if (filterSchedule) {
      this.setState({
        filtersProgramacao: filterSchedule
      });

    }

    const filters = JSON.parse(localStorage.getItem(("filtersStocksMulti")))
    this.setState(prevState => ({
      showFilter: true,
      filters: filters ?? prevState.filters
    }), () => {
      this.searchFilters(this.state.filters);
    })

    this.searchStockData();
  }

  proccessStocks = data => {
    this.setState({
      stocks: data.Data.map(x => mapDtoResponseStocks(x)),
      totalStocks: data.TotalItems
    });
  };

  processData = (property, data) => {
    this.setState({
      [property]: data
    });
  };

  showFilterProgramacao = () => {
    this.setState(prevState => ({
      showFilterProgramacao: !prevState.showFilterProgramacao,
      showFilter: false
    }));
  };

  showFilter = () => {
    this.setState(prevState => ({
      showFilter: !prevState.showFilter,
      showFilterProgramacao: false
    }));
  };

  closeFilter = filter => {
    this.setState({
      [filter]: false
    });
  };

   getFilterIcon = () =>{ 
    if(localStorage.getItem("THEME") != 1 )
      if(verifyIsFiltered(this.state.filters))
       return <IconFilterActive />
      else
       return <IconFilterInactive />
    else
      return undefined
  }
  searchFiltersProgramacao = filters => {
    this.showFilterProgramacao();
    StorePersist.setValuesJSON("filterSchedule", filters)
    this.setState(
      {
        stocks: [],
        loadRegs: 0,
        filtersProgramacao: filters
      },
      () => {
        this.searchStock();
      }
    );
  };

  handleSearchStocksFilter = filters => {
    this.searchFilters(filters)
  }

  searchFilters = filters => {
    this.showFilter();
    StorePersist.setValuesJSON("filtersStocksMulti", filters)
    this.setState({
      filters: filters,
      stocks: [],
      loadRegs: 0
    }, () => { this.searchStock(0) });
  };

  searchStockData = async () => {
    this.handleFetch();
    try {
      const user = Session.get();
      const data = await service.getStockData(this.state.useFilterDefault, user.Id)
      this.processData("usuariosProgramacao", data);
    } catch (err) {
      this.proccessError(err);
    }
    finally {
      this.handleFetch(false);
    }
  };

  redirectToDetail = (event, id) => {
    this.props.history.push(`stocksDetail/${id}`);
  };

  getStock = async () => {
    try {
      this.handleFetch();
      const { filtersProgramacao, filters } = this.state;
      const user = Session.get();

      const _filters = {
        ...mapDtoRequestStocks(filters, filtersProgramacao, user),
        _page: this.state.loadRegs,
        _size: this.state.regsPerRequest
      }

      const data = await service.getStock(_filters);

      this.setState({
        stocks: []
      }, () => this.proccessStocks(data));
    } catch (err) {
      this.proccessError(err);
    } finally {
      this.handleFetch(false);
    }
  }

  searchStock = async (loadRegs) => {
    this.setState({
      loadRegs
    }, () => { this.getStock() })
  };

  iniciarProgramacao = async (params) => {
    this.handleFetch();
    try {
      this.closeFilter("showFilterProgramacao");
      const user = Session.get();

      await service.startProgramming(params.idUsuarioProgramado, user.Id)

      await this.searchStockData();
      this.searchFiltersProgramacao(params);
    } catch (err) {
      this.proccessError(err);
    } finally {
      this.handleFetch(false);
    }
  };

  loadMore = (page) => {
    this.handleFetch();
    scrollToRef(this.contentScroll);

    this.setState(({
      loadRegs: page,
    }), () => { this.searchStock(this.state.loadRegs) })
    this.handleFetch(false);
  }

  handleFetch = (isFetching = true) => {
    this.setState(prevState => ({
      requestCounter: isFetching ? prevState.requestCounter + 1 : prevState.requestCounter - 1,
    }));
  };

  changeValue = value => {
    StorePersist.setValuesJSON("tipoVisualizacaoEstoque", value);
    this.setState({
      tipoVisualizacaoEstoque: value
    });
  };

  proccessError = (exception) => {
    this.setState({
      showMsg: true,
      titleMsg: intl.get('stocks.timeline.feedback.errorFound'),
      textMsg: formatErrorMessage(exception)
    });
  };

  render() {
    const { requestCounter, tipoVisualizacaoEstoque, stocks } = this.state;

    return (
      <div className="container-stocks" ref={this.contentScroll}>
        <Loading isLoading={requestCounter > 0} />
        <Header title={intl.get('stocks.header.title')}>
          <div className="buttons-header-container">
            <div
              title={`${intl.get('stocks.header.actions.programation')}${this.state.filtersProgramacao.usuarioSelecionado
                ? this.state.filtersProgramacao.usuarioSelecionado.Descricao
                : ""
                }`}
            >
              <ButtonIcon
                buttonType='tertiary'
                buttonIcon={<IconCalendarSchedule width={'35px'} height={'35px'}/>}
                onClick={this.showFilterProgramacao}
                style={{ width: '50px' }}
              />
            </div>
            <div className="filterContainer">
              <ButtonIcon
                onClick={this.showFilter}
                buttonType="secondary"
                buttonText={intl.get('filters.filter')}
                buttonIcon={this.getFilterIcon()}
                className={"button-filter"}
              />
            </div>
          </div>
        </Header>

        <Sidebar
          visible={this.state.showFilter}
          triggerClose={() => this.closeFilter("showFilter")}
          icon={IconEmpty}
        >
          <FilterStock
            searchStoks={this.handleSearchStocksFilter}
          />
        </Sidebar>

        <Sidebar
          visible={this.state.showFilterProgramacao}
          triggerClose={() => this.closeFilter("showFilterProgramacao")}
          icon={IconEmpty}
        >
          <FiltroProgramacao
            usuarios={this.state.usuariosProgramacao}
            showFilter={this.state.showFilterProgramacao}
            handleClose={this.searchFiltersProgramacao}
            initialData={this.state.filtersProgramacao}
            handleIniciarProgramacao={this.iniciarProgramacao}
          />
        </Sidebar>

        <div className="btn-tipo-visualizacao">
          <div className={`div-filters align-tipo-visualizacao`}>
            <div className="selectOptions">
              <SelectOption>
                <div title={intl.get('commons.vision.listView')}>
                  <Option
                    active={tipoVisualizacaoEstoque === "Lista" ? "active" : ""}
                    value="Lista"
                    handleClickIcon={() => this.changeValue("Lista")}
                    style={{ padding: "6px" }}
                  >
                    <IconList/>
                  </Option>
                </div>
                <div title={intl.get('commons.vision.cardView')}>
                  <Option
                    active={tipoVisualizacaoEstoque === "Grid" ? "active" : ""}
                    value="Grid"
                    handleClickIcon={() => this.changeValue("Grid")}
                    style={{ padding: "6px" }}
                  >
                    <ImgGrid/>
                  </Option>
                </div>
              </SelectOption>
            </div>
          </div>
        </div>
        {(stocks && stocks.length > 0) ?
          <React.Fragment>
            <div className="stocks-wrapper">
              {tipoVisualizacaoEstoque === "Grid" &&
                <div className="cards-container-stock">
                  {stocks.map((v) => (
                    <Card key={v.Id} dataCard={v} />
                  ))}
                </div>
              }
              {tipoVisualizacaoEstoque !== "Grid" &&
                <div className="card-container-task">
                  <ListStocks
                    data={stocks}
                    onClick={this.redirectToDetail}
                    contentListScroll={this.contentListScroll} />
                </div>
              }
            </div>
            <div className="paginationStock">
              <Pagination
                refreshSearch={this.loadMore}
                page={this.state.loadRegs}
                pageSize={this.state.regsPerRequest}
                amount={this.state.totalStocks}
              />
            </div>
          </React.Fragment>
          :
          <div className='no-records-message'>{intl.get('commons.noRecordsFound')}</div>
        }
        <Message
          show={this.state.showMsg}
          text={this.state.textMsg}
          title={this.state.titleMsg}
          handleClose={() => {
            this.setState({ showMsg: false });
          }}
        />
      </div>
    );
  }
}

export default withRouter(Stocks);
